import { xdc } from 'viem/chains'
import type { Client } from '../../client'
import { createClient } from '../../client'
import type { Explorer } from '../../explorer'
import { createEtherscanV2 } from '../../explorer'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'

export const createXdcNetworkChain = ({
  explorerApiKey: apiKey,
  explorerProxyUrl: proxyUrl,
  explorerPageSize: pageSize,
}: {
  explorerApiKey?: string
  explorerProxyUrl?: string
  explorerPageSize?: number
}): Chain =>
  createXdcNetworkChainCustom({
    client: createClient({ chain: xdc, httpRpcs: xdcNetworkHttpRpcs }),
    explorer: createEtherscanV2({
      name: 'XDCScan',
      baseUrl: 'https://xdcscan.com',
      chainId: 50,
      apiKey,
      proxyUrl,
      pageSize,
    }),
  })

type CreateXdcNetworkChainCustomParameters = {
  client: Client
  explorer: Explorer
}

export const createXdcNetworkChainCustom = ({
  client,
  explorer,
}: CreateXdcNetworkChainCustomParameters): Chain => ({
  id: 50,
  network: 'xdc-network',
  name: 'XDC Network',
  nativeToken: {
    name: 'XDC Network',
    symbol: 'XDC',
    decimals: 18,
    currency: {
      symbol: 'XDC',
      type: 'CryptoCurrency',
      id: 'xdce-crowd-sale',
      name: 'XDC Network',
      updatedAt: 0,
    },
  },
  wrappedTokenAddresses: new Set([
    '0x951857744785e80e2de051c32ee7b25f9c458c42',
  ]),
  explorer,
  client,
  blockTime: undefined,
  coingeckoId: 'xdc-network',
  defillamaId: undefined,
})

export const xdcNetworkHttpRpcs: HttpRpc[] = [
  {
    url: 'https://rpc.xdcrpc.com',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://rpc1.xinfin.network',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://erpc.xinfin.network',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://erpc.xdcrpc.com',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://rpc.xdc.org',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://earpc.xinfin.network',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://erpc.xinfin.network',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://rpc.ankr.com/xdc',
    getLogsIsUsable: false,
    getLogsMaxBlockRange: 0n,
  },
  {
    url: 'https://xdc-mainnet.gateway.tatum.io',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
]

export const xdcNetworkWebsocketRpcUrls: string[] = [
  'wss://rpc.xdcrpc.com/ws',
  'wss://erpc.xdcrpc.com/ws',
  'wss://ews.xinfin.network/ws',
]
